import { useContext } from 'react';
import EntityTypesContext from 'helpers/EntityTypesContext';

export const PERSON_ENTITY_TYPE_KEY = 'user';

export default function useEntityTypes() {
  const entityTypes = useContext(EntityTypesContext);

  if (!entityTypes) {
    throw new Error('[useEntityTypes] expected entity types to be truthy');
  }

  return entityTypes;
}
